import Vue from "vue";
import OTelInput from "o-tel-input";

Vue.filter("formatDate", (unix_timestamp: number, format?: string) => {
	// @ts-ignore
	moment.locale(app.configs.get("OW_APP_DEFAULT_LANG"));
	format = format || "MMM Do, h:mm a";

	// @ts-ignore
	return moment(unix_timestamp * 1000).format(format);
});

Vue.filter("sinceDate", (unix_timestamp: number) => {
	// @ts-ignore
	moment.locale(app.configs.get("OW_APP_DEFAULT_LANG"));
	// @ts-ignore
	return moment(unix_timestamp * 1000).fromNow();
});

Vue.filter("dateInputValue", (unix_timestamp: number) => {
	// @ts-ignore
	return moment(unix_timestamp * 1000).format("YYYY-MM-DDThh:mm");
});

Vue.filter("formatPhone", (phone: string) => {
	return new OTelInput({ "number": phone }).getInput(true);
});

Vue.filter("formatPrice", (price: any, currency: string) => {
	price = parseInt(price).toLocaleString();

	if (currency === "USD") {
		return "$ " + price + " USD";
	}

	return price + " XOF";
});

Vue.filter("shortText", (text: string, len?: number, ellipsis?: string) => {
	len = len || 100;
	ellipsis = text.length > len ? ellipsis || "..." : "";
	text = text.substr(0, len);
	return text.length ? text + ellipsis : "";
});

Vue.filter("lineToBr", (text: string) => {
	return (text || "").replace(/\\r\\n|\\n/g, "<br/>");
});
